import type { ComponentPropsWithoutRef, FC } from 'react';
import GmailColor from 'src/assets/svgicons/brands/GmailColor.svg';
import MicrosoftTeamsColor from 'src/assets/svgicons/brands/MicrosoftTeamsColor.svg';
import Dataflow01 from 'src/assets/svgicons/duotone/dataflow-01.svg';
import { Badge } from 'src/components/Badge';
import { cn } from 'src/lib/cn';

const comingSoonItems = [
  {
    name: 'Email',
    description: 'Get updates delivered to your inbox',
    icon: <GmailColor />,
  },
  {
    name: 'Teams',
    description: 'Receive updates in Microsoft Teams',
    icon: <MicrosoftTeamsColor />,
  },
  {
    name: 'API',
    description: 'Integrate with your existing tools',
    icon: <Dataflow01 />,
  },
];

const ComingSoonReportingPlatforms: FC<ComponentPropsWithoutRef<'ul'>> = ({
  className,
  ...props
}) => {
  return (
    <ul className={cn('space-y-4', className)} {...props}>
      {comingSoonItems.map((item) => (
        <li
          key={item.name}
          className="flex items-center gap-3 rounded-xl border border-solid border-purple-200 bg-white px-4 py-3 *:opacity-50"
        >
          <div className="rounded-lg border border-solid border-secondary/80 bg-white p-2">
            {item.icon}
          </div>
          <div className="space-y-0.5">
            <div className="flex items-center gap-2">
              <h3 className="text-sm font-semibold">{item.name}</h3>
              <Badge
                className="bg-purple-100 text-xxs text-primary/70"
                variant="pill"
              >
                Coming soon
              </Badge>
            </div>
            <p className="text-xs text-[#917dd2]">{item.description}</p>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ComingSoonReportingPlatforms;
